let token = null;

/**
 * @export
 */
let send = () => {};

const url = `wss://ws.${window.rsvDomain}/wss?jwt=`;

const registerSecurityService = (securityService) => {
    securityService.addUserListener((user) => {
        token = user ? user.access_token : null;
        connect();
    });
};

/**
 * Колбэки для обработки разных типов сообщений
 */
const services = {};

/**
 * @export
 *
 * @param {object} fnObj
 */
const setServices = fnObj => {
    Object.keys(fnObj).forEach(key => {
        // TODO Почему if ( ! services[key]) ?
        if (!services[key]) services[key] = fnObj[key];
    });
};

/**
 * @param socket
 * @returns {Function} - функция отправки сообщений на сервер
 */
const createSend = socket => {
    /**
     * @param {string} event - тип сообщения
     * @param {object} data - тело сообщения
     */
    return (event, data) => {
        const message = {
            'jwt': token,
            'name': event,
            'payload': data,
        };

        if (socket.readyState == 1) {
            socket.send(JSON.stringify(message));
        }
    };
};

let socket;

let connectTime = null;
const WS_TIME_LIMIT = () => (window.rsvWebsocketsTimeout || 3600) * 1000;

setInterval(() => {
    if (socket && connectTime) {
        const time = new Date().getTime();
        const diff = time - connectTime;

        if (diff >= WS_TIME_LIMIT()) {
            console.log('WS: превышен лимит времени соединения');
            socket.close();
            socket = null;
            connectTime = null;
        }
    }
}, 5000);

/**
 * @export
 */
const connect = () => {
    if (!token || token == '') return;
    if (socket) {
        socket.close();
    }
    socket = new WebSocket(url + token);

    send = createSend(socket);

    socket.onopen = () => {
        console.log("WS: Соединение установлено");
        connectTime = new Date().getTime();
    };

    socket.onmessage = event => {
        if (event.data == 'PING') {
            socket.send('PONG');
            return;
        }
        const response = JSON.parse(event.data);

        if (services[response.service]) {
            connectTime = new Date().getTime();
            services[response.service](response.payload);
        }
    };

    socket.onclose = (e) => {
        console.log('WS: Соединение закрыто', e);
    };
    socket.onerror = (e) => {
        console.log("WS: Ошибка соединения", e);
        socket.close();
    };
};

export {
    setServices as wsSetServices,
    connect as wsConnect,
    send as wsSend,
    registerSecurityService,
};
